



























import { defineComponent } from "@vue/composition-api";
import { Icon, Button, Field, Popup, DatetimePicker } from "vant";
import moment from "moment";

moment.locale("zh-cn");

export default defineComponent({
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  data: () => ({
    startDate: moment()
      .subtract(1, "months")
      .startOf("month")
      .format("YYYY-MM-DD"),
    endDate: moment()
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD"),
    showStartPicker: false,
    showEndPicker: false,
    email: localStorage.getItem("settleExportEmail") || "",
    emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    minDate: new Date(2025, 3, 1)
  }),
  computed: {
    startDateObj() {
      return this.startDate ? new Date(this.startDate) : new Date();
    },
    endDateObj() {
      return this.endDate ? new Date(this.endDate) : new Date();
    },
    isValidEmail() {
      return this.email && this.emailPattern.test(this.email);
    },
    isValidDateRange() {
      if (!this.startDate || !this.endDate) return false;
      const start = moment(this.startDate);
      const end = moment(this.endDate);
      const diffDays = end.diff(start, "days");
      return diffDays >= 0 && diffDays <= 31;
    }
  },
  created() {},
  methods: {
    onStartDateConfirm(date) {
      this.startDate = moment(date).format("YYYY-MM-DD");
      this.showStartPicker = false;
    },
    onEndDateConfirm(date) {
      this.endDate = moment(date).format("YYYY-MM-DD");
      this.showEndPicker = false;
    },
    exportData() {
      if (!this.startDate || !this.endDate) {
        this.$toast("请选择开始和结束日期");
        return;
      }

      if (!this.isValidDateRange) {
        this.$toast("请正确提供开始和结束日期，且相差不超过31天");
        return;
      }

      if (!this.isValidEmail) {
        this.$toast("请输入有效的邮箱地址");
        return;
      }

      this.$axios
        .post("/api/manage/settle/export", {
          startDate: this.startDate,
          endDate: this.endDate,
          email: this.email
        })
        .then(() => {
          localStorage.setItem("settleExportEmail", this.email);
          this.$toast.success("导出成功");
        })
        .catch();
    },
    dateFormat(date: string) {
      return moment(date).format("YYYY-MM-DD");
    },
    timeFormat(date: string) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    amountFormat(amount: number) {
      return amount / 100.0;
    }
  }
});
